var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('emailsIntro'),_vm._v(" "),_c('successAdminEmail'),_vm._v(" "),_c('successUserEmail'),_vm._v(" "),_c('errorAdminEmail'),_vm._v(" "),_c('errorUserEmail')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d78c1410","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmailsSettings/emailsSettings.vue
// module id = 454
// module chunks = 0